export default function Cleaning() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Cleaning</h1>
      <p className="text-gray-600">Manage data cleaning processes</p>
    </div>
  );
}

